// Plus by Kirk Draheim from the Noun Project
// https://thenounproject.com/term/plus/3539744

import * as React from "react";

export function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 25 25" {...props}>
			<path d="M12.5 0c.6 0 1 .4 1 1v10.5H24c.5 0 .9.4 1 .9v.1c0 .6-.4 1-1 1H13.5V24c0 .5-.4.9-.9 1h-.1c-.6 0-1-.4-1-1V13.5H1c-.5 0-.9-.4-1-.9v-.1c0-.6.4-1 1-1h10.5V1c0-.5.4-.9.9-1h.1z" />
		</svg>
	);
}

// edit by Markus from the Noun Project (edited)
// https://thenounproject.com/term/edit/3126120

export function EditIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 70 70" {...props}>
			<path d="M9.44 43.24L50.22 2.46a2.45 2.45 0 013.46 0l13.85 13.86a2.45 2.45 0 010 3.47L26.77 60.56zM1.85 64A3.4 3.4 0 006 68.16l17.49-4.29L6.14 46.54z" />
		</svg>
	);
}

// @TODO Link to the one in pages - this has been brought here from there
// Arrow by Kirsh from the Noun Project (edited)
// https://thenounproject.com/term/arrow/1256496

export function ArrowIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 64 64" {...props} id="back">
			<path d="M15.64 62.8a4.1 4.1 0 005.8 0l27.88-27.86a4.1 4.1 0 000-5.8L21.44 1.27a4.1 4.1 0 00-5.94 5.66l.15.15 25 25-25 25a4.1 4.1 0 000 5.8z" />
		</svg>
	);
}

// Delete by Fantastic from the Noun Project (edited)
// https://thenounproject.com/term/delete/1393049

export function DeleteIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 68 68" {...props}>
			<path d="M60.33 12.15H43.45V9.24A5.2 5.2 0 0038.22 4H29a5.2 5.2 0 00-5.23 5.23v2.91H7.6a1.49 1.49 0 100 3h3.73l3.29 43.32a6 6 0 006 5.53h26.04a6 6 0 006-5.53l3.29-43.32h4.45a1.5 1.5 0 001.49-1.49 1.56 1.56 0 00-1.56-1.5zM26.72 9.24A2.2 2.2 0 0129 7h9.34a2.2 2.2 0 012.24 2.24v2.91H26.72zm-1.27 44.14h-.07a1.48 1.48 0 01-1.5-1.38l-1.49-27.6a1.5 1.5 0 013-.15l1.49 27.56a1.55 1.55 0 01-1.43 1.57zm9.63-1.49a1.49 1.49 0 11-3 0V24.33a1.49 1.49 0 013 0zm8.22.11a1.48 1.48 0 01-1.49 1.42h-.07a1.5 1.5 0 01-1.42-1.57l1.48-27.6a1.55 1.55 0 011.57-1.42 1.5 1.5 0 011.42 1.57z" />
		</svg>
	);
}
